document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('header-component');
  if (!header) return;

  const pageWrapper = document.querySelector('.page-wrapper');

  function getScrollY() {
    const wrapperScroll = pageWrapper ? pageWrapper.scrollTop : 0;
    const windowScroll = window.scrollY || document.documentElement.scrollTop || 0;
    return Math.max(wrapperScroll, windowScroll);
  }

  function onScroll() {
    if (getScrollY() > 50) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }
  }

  if (pageWrapper) {
    pageWrapper.addEventListener('scroll', onScroll, { passive: true });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});
